import React, { useState, useEffect } from "react";
import {
  FaCalendarCheck,
  FaCalendarAlt,
  FaThumbsUp,
  FaThumbsDown,
  FaUserEdit,
  FaUserPlus,
  FaBalanceScale,
} from "react-icons/fa";
import redBear from "./Img/redbear (2).png";
import greenBull from "./Img/greenbull (2).png";
import mixedDay from "./Img/mixedicon.png";
import { fetchData } from './../../apiService';
import { useLocation, Link } from 'react-router-dom';

const HomePage = () => {
  const [showModal, setShowModal] = useState(false);
  const [weekDates, setWeekDates] = useState([]);

  const [showDailyModal, setShowDailyModal] = useState(false);
  const [dailyPredictions, setDailyPredictions] = useState([]);

  const [showMonthlyModal, setShowMonthlyModal] = useState(false);
  const [monthDates, setMonthDates] = useState([]);

  // Function to calculate the current week dates
  const calculateWeek = () => {
    const today = new Date();
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    setWeekDates(dates);
  };

  const handleWeeklyClick = () => {
    calculateWeek();
    setShowModal(true);
  };

  // Function to handle daily predictions click
  const handleDailyClick = () => {
    setDailyPredictions([{
      icon: redBear,
      time: "8.30 a m to 10.59 a m",
      date: "06/07/2018",
      message: [
        "It’s not a favourable day for trading or taking risky decisions.",
        "Please avoid impulsive trades."
      ]
    }, {
      icon: greenBull,
      time: "11.00 a m to 11.59 p m",
      date: "06/07/2018",
      message: [
        "It’s not a favourable day for trading or taking risky decisions.",
        "Please avoid impulsive trades."
      ]
    }]);
    setShowDailyModal(true);
  };

  // Function to calculate the current month dates
  const calculateMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const dates = [];
    const totalDays = new Date(year, month + 1, 0).getDate();
    for (let i = 1; i <= totalDays; i++) {
      dates.push(new Date(year, month, i));
    }
    setMonthDates(dates);
  };

  const [usersubscriptionplan, setUsersubscriptionplan] = useState();
  const [paddedDates, setPaddedDates] = useState([]);
  const [planRangeText, setPlanRangeText] = useState("");

  const handleMonthlyClick = async () => {
    const companyId = 1;
    const userid = 1;
    try {
      const response = await fetchData('UserApi', `/UserSubscriptionPlan/${userid}`);
      if (response.responseCode === '1111') {
        const plan = response.response_data;
        setUsersubscriptionplan(plan);

        const planStartDate = new Date(plan.PlanStartDate);
        const planEndDate = new Date(plan.PlanEndDate);

        //setPlanRangeText(`${planStartDate.toLocaleDateString()} to ${planEndDate.toLocaleDateString()}`);
        setPlanRangeText(
          `${planStartDate.getDate().toString().padStart(2, "0")}-${planStartDate.toLocaleString("en-US", {
            month: "long",
          })}-${planStartDate.getFullYear()} to ${planEndDate.getDate().toString().padStart(2, "0")}-${planEndDate.toLocaleString("en-US", {
            month: "long",
          })}-${planEndDate.getFullYear()}`
        );


        // Generate date range
        const generatePlanDates = (start, end) => {
          const dates = [];
          let current = new Date(start);
          while (current <= end) {
            dates.push(new Date(current));
            current.setDate(current.getDate() + 1);
          }
          return dates;
        };

        const planDates = generatePlanDates(planStartDate, planEndDate);

        // Pad start
        const fullPaddedDates = [];
        for (let i = 0; i < planStartDate.getDay(); i++) {
          fullPaddedDates.push(null);
        }

        fullPaddedDates.push(...planDates);

        // Pad end to complete full weeks
        while (fullPaddedDates.length % 7 !== 0) {
          fullPaddedDates.push(null);
        }

        setPaddedDates(fullPaddedDates);
        setShowMonthlyModal(true);
      }
    } catch (error) {
      console.error('Error fetching Subscription Plans Details:', error);
    }
  };

  // Function to get the status icon based on index
  const getStatusIcon = (index) => {
    const status = index % 3;
    if (status === 0) return greenBull;
    if (status === 1) return redBear;
    return mixedDay;
  };

  const getDayName = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "short" });
  };

  // Function to handle day click in monthly view
  const handleDayClick = (date, iconType) => {
    const icon = iconType;
    const dateStr = date.toLocaleDateString();
    const predictions = [
      {
        time: "9:00 AM to 11:30 AM",
        icon,
        date: dateStr,
        message: icon === greenBull
          ? ["Favorable time for trading.", "Momentum may increase post opening."]
          : icon === redBear
            ? ["Avoid trading in early hours.", "Volatility is high."]
            : ["Uncertain market conditions.", "Better wait till afternoon."]
      },
      {
        time: "2:00 PM to 4:00 PM",
        icon,
        date: dateStr,
        message: icon === greenBull
          ? ["Good time to take positions.", "Tech stocks may perform well."]
          : icon === redBear
            ? ["Avoid long positions.", "News-driven drops possible."]
            : ["Be cautious. Mixed trends in sectors."]
      }
    ];
    setDailyPredictions(predictions);
    setShowDailyModal(true);
  };

  // State for Good Days modal
  const [showGoodDaysModal, setShowGoodDaysModal] = useState(false);
  const [goodDaysList, setGoodDaysList] = useState([]);

  const handleGoodDaysClick = () => {
    calculateWeek();
    const predictions = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const icon = getStatusIcon(i);

      if (icon === greenBull) {
        predictions.push({
          date: date.toLocaleDateString(),
          day: getDayName(date),
          time: "9:00 AM to 11:30 AM & 2:00 PM to 4:00 PM",
          message: [
            "Favorable time for trading.",
            "Momentum may increase post opening."
          ]
        });
      }
    }

    setGoodDaysList(predictions);
    setShowGoodDaysModal(true);
  };

  // State for Bad Days modal
  const [showBadDaysModal, setShowBadDaysModal] = useState(false);
  const [badDaysList, setBadDaysList] = useState([]);

  const handleBadDaysClick = () => {
    calculateWeek();
    const predictions = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const icon = getStatusIcon(i);

      if (icon === redBear) {
        predictions.push({
          date: date.toLocaleDateString(),
          day: getDayName(date),
          time: "9:00 AM to 11:30 AM & 2:00 PM to 4:00 PM",
          message: [
            "Avoid trading in early hours.",
            "Volatility is high."
          ]
        });
      }
    }

    setBadDaysList(predictions);
    setShowBadDaysModal(true);
  };

  // State for Mixed Days modal
  const [showMixedDaysModal, setShowMixedDaysModal] = useState(false);
  const [mixedDaysList, setMixedDaysList] = useState([]);

  const handleMixedDaysClick = () => {
    calculateWeek();
    const predictions = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const icon = getStatusIcon(i);

      if (icon === mixedDay) {
        predictions.push({
          date: date.toLocaleDateString(),
          day: getDayName(date),
          time: "9:00 AM to 11:30 AM & 2:00 PM to 4:00 PM",
          message: [
            "Uncertain market conditions.",
            "Better wait till afternoon."
          ]
        });
      }
    }

    setMixedDaysList(predictions);
    setShowMixedDaysModal(true);
  };

  // Edit Profile functionality
  const handleEditProfileClick = () => {
    const userid = 1; // Assuming a static user ID for demonstration
    const editProfileUrl = `/EditUserProfile/${userid}`;
    window.location.href = editProfileUrl;
  };

  const userid = 1; // Assuming a static user ID for demonstration
  const menuItems = [
    { label: "Daily", icon: <FaCalendarCheck />, action: handleDailyClick },
    { label: "Weekly", icon: <FaCalendarAlt />, action: handleWeeklyClick },
    { label: "Monthly", icon: <FaCalendarAlt />, action: handleMonthlyClick },
    { label: "Good Days", icon: <FaThumbsUp />, action: handleGoodDaysClick },
    { label: "Bad Days", icon: <FaThumbsDown />, action: handleBadDaysClick },
    { label: "Mixed Days", icon: <FaBalanceScale />, action: handleMixedDaysClick },
    { label: "Edit Profile", icon: <FaUserEdit />, action: handleEditProfileClick },
    // {
    //   label: "Edit Profile",
    //   icon: <FaUserEdit />,
    //   element: <Link to={`/EditUserProfile/${userid}`}>Edit Profile</Link>
    // },
    { label: "Add User", icon: <FaUserPlus /> }
  ];

  let lastMonth = null;

  return (
    <div style={{ padding: "20px", fontFamily: "monospace" }}>
      <div className="home-grid" style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {menuItems.map((item, index) => (
          <div
            key={index}
            onClick={item.action}
            style={{
              borderRadius: "16px",
              boxShadow: "4px 4px 8px #e5e2e2, -6px -6px 12px #110404",
              textAlign: "center",
              padding: "20px 10px",
              transition: "all 0.3s ease",
              cursor: "pointer",
              fontSize: "16px",
              color: "whitesmoke",
              background: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              minWidth: "100px",
              flex: "1 0 120px",
            }}
          >
            <div style={{ fontSize: "24px" }}>{item.icon}</div>
            <div style={{ fontWeight: "bold", marginTop: "10px" }}>{item.label}</div>
          </div>
        ))}
      </div>

      {showMonthlyModal && usersubscriptionplan && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#1e1e1e", padding: "20px", borderRadius: "16px",
            width: "95%", maxWidth: "800px", textAlign: "center", color: "white", fontFamily: "monospace"
          }}>
            <h6 style={{ fontWeight: "bold" }}>MONTHLY OVERVIEW</h6>

            <div style={{ fontWeight: "bold", marginBottom: "20px" }}>
              {planRangeText}
            </div>

            <div style={{
              display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "6px",
              background: "#2e2e2e", padding: "10px", borderRadius: "8px"
            }}>
              {["S", "M", "T", "W", "T", "F", "S"].map((day, i) => (
                <div key={i} style={{
                  textAlign: "center", fontWeight: "bold", color: "black",
                  background: "whitesmoke", borderRadius: "5px", padding: "1px"
                }}>{day}</div>
              ))}

              {paddedDates.map((date, index) => {
                if (!date) return <div key={index}></div>; // padding empty cells

                const today = new Date();
                const isToday =
                  date.getDate() === today.getDate() &&
                  date.getMonth() === today.getMonth() &&
                  date.getFullYear() === today.getFullYear();

                const icon = getStatusIcon(index); // or date-based index if needed

                return (
                  <div
                    key={index}
                    onClick={() => handleDayClick(date, icon)}
                    style={{
                      background: isToday ? "#f3bf7aff" : "#1e1e1e",
                      borderRadius: "10px",
                      padding: "6px 4px",
                      textAlign: "center",
                      border: isToday ? "2px solid #062720ff" : "1px solid white",
                      fontSize: "14px",
                      minHeight: "50px",
                      cursor: "pointer",
                      color: isToday ? "darkblue" : "white",
                      fontWeight: isToday ? "bold" : "normal",
                    }}
                  >
                    {/* <div>{String(date.getDate()).padStart(2, "0")}</div> */}
                    <div>
                      {String(date.getDate()).padStart(2, "0")}{" "}
                      <span style={{ fontSize: "10px", color: isToday ? "darkblue" : "white", }}>
                        {date.toLocaleString("default", { month: "short" })}
                      </span>
                    </div>
                    <img src={icon} alt="status" style={{ width: "20px", marginTop: "4px" }} />
                  </div>
                );
              })}
            </div>

            <button style={{
              marginTop: "20px", background: "crimson", color: "white",
              padding: "10px 20px", border: "none", borderRadius: "8px"
            }}
              onClick={() => setShowMonthlyModal(false)}
            >Close</button>
          </div>
        </div>
      )}

      {showModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#1e1e1e",
            padding: "20px",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "420px",
            textAlign: "center",
            color: "white",
            fontFamily: "monospace",
            boxShadow: "0 0 20px rgba(0,0,0,0.3)"
          }}>
            <h6 style={{ fontFamily: "monospace", fontWeight: "bold" }}>WEEKLY OVERVIEW</h6>
            {/* <div style={{ fontWeight: "bold", marginBottom: "20px" }}>
              {weekDates[0]?.toLocaleDateString()} to {weekDates[6]?.toLocaleDateString()}
            </div>*/}

            <div style={{ fontWeight: "bold", marginBottom: "20px" }}>
              {weekDates[0] &&
                `${weekDates[0].getDate().toString().padStart(2, "0")}-${weekDates[0].toLocaleString("en-US", {
                  month: "long",
                })}-${weekDates[0].getFullYear()}`}{" "}
              to{" "}
              {weekDates[6] &&
                `${weekDates[6].getDate().toString().padStart(2, "0")}-${weekDates[6].toLocaleString("en-US", {
                  month: "long",
                })}-${weekDates[6].getFullYear()}`}
            </div>


            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
              marginBottom: "20px",
              background: "#2e2e2e"
            }}>
              {weekDates.map((date, index) => {
                const icon = getStatusIcon(index);
                const today = new Date();
                const isToday =
                  date.getDate() === today.getDate();
                return (
                  <div
                    key={index}
                    onClick={() => handleDayClick(date, icon)}
                    style={{
                      background: isToday ? "rgb(230, 233, 91)" : "#1e1e1e",
                      borderRadius: "10px",
                      padding: "10px",
                      boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
                      fontWeight: "bold",
                      fontSize: "16px",
                      border: isToday ? "2px solid #052b23ff" : "1px solid white",
                      cursor: "pointer",
                      transition: "transform 0.2s ease",
                      color: isToday ? "darkblue" : "white",
                      fontWeight: isToday ? "bold" : "normal",
                    }}
                  >
                    <div>{getDayName(date)} {String(date.getDate()).padStart(2, "0")}</div>
                    <div style={{ fontSize: "20px", marginTop: "5px" }}>
                      <img src={icon} alt="status" style={{ width: "32px" }} />
                    </div>
                  </div>
                );
              })}
            </div>

            <button style={{
              background: "crimson",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer"
            }} onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}

      {showDailyModal && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
          <div style={{ background: "#1e1e1e", padding: "20px", borderRadius: "16px", width: "90%", maxWidth: "420px", textAlign: "center", color: "white", fontFamily: "monospace" }}>
            <h6 style={{ fontWeight: "bold", fontFamily: 'monospace' }}>DAILY OVERVIEW</h6>
            {dailyPredictions.map((entry, index) => (
              <div key={index} style={{ marginBottom: "20px", borderRadius: "12px", padding: "15px", background: "#2e2e2e" }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto 10px" }}>
                  <img src={entry.icon} alt="status" style={{ width: "40px", height: "40px" }} />
                </div>
                <div style={{ background: "#ccc", borderRadius: "6px", padding: "5px 10px", fontWeight: "bold", fontSize: "14px", color: "black" }}>
                  {entry.date}, <span style={{ color: "#0077cc" }}>{entry.time}</span>
                </div>
                <div style={{ textAlign: "left", marginTop: "10px" }}>
                  {entry.message.map((line, idx) => (
                    <p key={idx} style={{ margin: 0, fontWeight: "bold", color: "white" }}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
            <button style={{ background: "crimson", color: "white", padding: "10px 20px", border: "none", borderRadius: "8px", cursor: "pointer" }} onClick={() => setShowDailyModal(false)}>Close</button>
          </div>
        </div>
      )}

      {showGoodDaysModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#1e1e1e",
            padding: "20px",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "600px",
            color: "white",
            fontFamily: "monospace",
            boxShadow: "0 0 20px rgba(0,0,0,0.3)"
          }}>
            <h6 style={{ fontWeight: "bold", fontFamily: 'monospace', textAlign: 'center' }}>WEEKLY GOOD DAYS OVERVIEW</h6>
            {goodDaysList.length === 0 ? (
              <p style={{ textAlign: "center", color: "lightgray" }}>No good days in this week.</p>
            ) : (
              goodDaysList.map((item, index) => (
                <div key={index} style={{
                  background: "#2e2e2e",
                  padding: "15px",
                  marginBottom: "12px",
                  borderRadius: "10px",
                  border: "1px solid #00cc66"
                }}>
                  <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
                    {item.day}, {item.date}
                  </div>
                  <div style={{ color: "#00cc66", fontWeight: "bold" }}>
                    {item.time}
                  </div>
                  <div style={{ marginTop: "10px", color: "white" }}>
                    {item.message.map((msg, idx) => (
                      <p key={idx} style={{ margin: 0 }}>{msg}</p>
                    ))}
                  </div>
                </div>
              ))
            )}

            <button style={{
              background: "crimson",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "block",
              margin: "0 auto"
            }} onClick={() => setShowGoodDaysModal(false)}>Close</button>
          </div>
        </div>
      )}

      {showBadDaysModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#1e1e1e",
            padding: "20px",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "600px",
            color: "white",
            fontFamily: "monospace",
            boxShadow: "0 0 20px rgba(214, 16, 16, 0.3)"
          }}>
            <h6 style={{ fontWeight: "bold", fontFamily: 'monospace', textAlign: 'center' }}>WEEKLY BAD DAYS OVERVIEW</h6>
            {badDaysList.length === 0 ? (
              <p style={{ textAlign: "center", color: "lightgray" }}>No Bad days in this week.</p>
            ) : (
              badDaysList.map((item, index) => (
                <div key={index} style={{
                  background: "#2e2e2e",
                  padding: "15px",
                  marginBottom: "12px",
                  borderRadius: "10px",
                  border: "1px solid rgb(235, 118, 82)"
                }}>
                  <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
                    {item.day}, {item.date}
                  </div>
                  <div style={{ color: "rgb(243, 115, 76)", fontWeight: "bold" }}>
                    {item.time}
                  </div>
                  <div style={{ marginTop: "10px", color: "white" }}>
                    {item.message.map((msg, idx) => (
                      <p key={idx} style={{ margin: 0 }}>{msg}</p>
                    ))}
                  </div>
                </div>
              ))
            )}

            <button style={{
              background: "crimson",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "block",
              margin: "0 auto"
            }} onClick={() => setShowBadDaysModal(false)}>Close</button>
          </div>
        </div>
      )}

      {showMixedDaysModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#1e1e1e",
            padding: "20px",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "600px",
            color: "white",
            fontFamily: "monospace",
            boxShadow: "0 0 20px rgba(0,0,0,0.3)"
          }}>
            <h6 style={{ fontWeight: "bold", fontFamily: 'monospace', textAlign: 'center' }}>WEEKLY MIXED DAYS OVERVIEW</h6>
            {mixedDaysList.length === 0 ? (
              <p style={{ textAlign: "center", color: "lightgray" }}>No Mixed days in this week.</p>
            ) : (
              mixedDaysList.map((item, index) => (
                <div key={index} style={{
                  background: "#2e2e2e",
                  padding: "15px",
                  marginBottom: "12px",
                  borderRadius: "10px",
                  border: "1px solid rgb(241, 239, 79)"
                }}>
                  <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
                    {item.day}, {item.date}
                  </div>
                  <div style={{ color: "rgb(245, 232, 115)", fontWeight: "bold" }}>
                    {item.time}
                  </div>
                  <div style={{ marginTop: "10px", color: "white" }}>
                    {item.message.map((msg, idx) => (
                      <p key={idx} style={{ margin: 0 }}>{msg}</p>
                    ))}
                  </div>
                </div>
              ))
            )}

            <button style={{
              background: "crimson",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "block",
              margin: "0 auto"
            }} onClick={() => setShowMixedDaysModal(false)}>Close</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default HomePage;
